import React from "react";

function OutOfStockIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4353_5409)">
        <path
          d="M15 1H1V5.10526H1.7V12.6316C1.7 12.9945 1.8475 13.3426 2.11005 13.5992C2.3726 13.8558 2.7287 14 3.1 14H12.9C13.2713 14 13.6274 13.8558 13.8899 13.5992C14.1525 13.3426 14.3 12.9945 14.3 12.6316V5.10526H15V1ZM2.4 2.36842H13.6V3.73684H2.4V2.36842ZM12.9 12.6316H3.1V5.10526H12.9V12.6316ZM5.9 6.47368H10.1C10.1 6.83661 9.9525 7.18468 9.68995 7.4413C9.4274 7.69793 9.0713 7.84211 8.7 7.84211H7.3C6.9287 7.84211 6.5726 7.69793 6.31005 7.4413C6.0475 7.18468 5.9 6.83661 5.9 6.47368Z"
          fill="#424242"
        />
      </g>
      <defs>
        <clipPath id="clip0_4353_5409">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default OutOfStockIcon;
